import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["aria-level", "tagName"];
import styled from 'styled-components';
import { useFoundationsReadinessTracking } from '../utils/useFoundationsReadinessTracking';
import { jsx as _jsx } from "react/jsx-runtime";
const Heading = styled(_ref => {
  let {
      'aria-level': ariaLevel = 2,
      tagName: Tag = 'span'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  useFoundationsReadinessTracking();
  return /*#__PURE__*/_jsx(Tag, Object.assign({
    "aria-level": ariaLevel
  }, rest));
}).withConfig({
  displayName: "Heading"
})([""]);
export default Heading;